import { combineReducers } from 'redux-immutable'
import { fromJS } from 'immutable'

// constants
import { CHANGE_LOCALE, DEFAULT_LOCALE } from 'constants.js';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = fromJS({
  locale: DEFAULT_LOCALE,
  locationBeforeTransitions: null,
});

const app = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set('locale', action.locale);

    case LOCATION_CHANGE:
      return state.set('locationBeforeTransitions', action.payload);

    default:
      return state;
  }
};

export default combineReducers({
  app,
})


// WEBPACK FOOTER //
// ./src/reducers.js